export const CURRENCY_FORMAT = '$0,0.00';
